<template>
  <div>
    <!-- $ 筛选 模块 -->
    <div class="pick-box">
      <div class="tit">我的达人</div>
      <div class="main">
        <div class="item">
          <div class="l">抖音昵称</div>
          <div class="r">
            <el-input
              size="mini"
              v-model="formData.goodsTit"
              placeholder="请输入抖音昵称"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <div class="l">抖音号</div>
          <div class="r">
            <el-input
              size="mini"
              v-model="formData.goodsTit"
              placeholder="请输入抖音号"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <div class="l">联系人</div>
          <div class="r">
            <el-input size="mini" v-model="formData.goodsTit" placeholder="请输入联系人"></el-input>
          </div>
        </div>
         <div class="item">
          <div class="l">出单时间</div>
          <div class="r">
            <el-date-picker
              v-model="timeSelest"
              type="daterange"
              align="right"
              size="mini"
              unlink-panels
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format='yyyy-MM-dd'
              value-format="yyyy-MM-dd"
              style="width: 190px"
              >
            </el-date-picker>
          </div>
        </div>
        <div class="btn-box">
          <el-button size="mini" type="danger">搜索</el-button>
          <el-button size="mini">重置</el-button>
        </div>
      </div>
    </div>

    <!-- $ 表格 模块 -->
    <div class="table-box">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="商品信息" width="380">
          <!-- <template slot-scope="scope"> -->
          <template>
            <div class="goodsInfo">
              <img src="" alt="" />
              <div class="r">
                <div class="tit">黄宝宝百货店</div>
                <div class="txt">抖音号：1015076869</div>
                <div class="txt">粉丝数：192.29w</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="寄样数">
          <!-- <template slot-scope="scope"> -->
          <template>
            <div class="num-box">223</div>
          </template>
        </el-table-column>
        <el-table-column label="合作数据">
          <!-- <template slot-scope="scope"> -->
          <template>
            <div class="num-box">
              <div>现售：<span>￥223.2</span></div>
              <div>现售：<span>￥223.2</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="橱窗数据">
          <!-- <template slot-scope="scope"> -->
          <template>
            <div class="num-box">
              <div>现售：<span>￥223.2</span></div>
              <div>现售：<span>￥223.2</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" width="260">
          <!-- <template slot-scope="scope"> -->
          <template>
            <div class="num-box">
              <div>托管：<span>--</span></div>
              <div>手机：<span>--</span></div>
              <div>微信：<span>--</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="跟进人" width="260">
          <!-- <template slot-scope="scope"> -->
          <template>
            <div class="num-box">小喃喃棉花糖</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" fixed="right">
          <template>
            <div class="btn-box">
              <div @click="addTalent()">添加联系人</div>
              <div>备注</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <talentDialog :talentVisible='talentVisible' @close='close' @success='success'></talentDialog>
    </div>
  </div>
</template>

<script>
  import talentDialog from './addTalentDialog/index.vue'
  export default {
    data() {
      return {
        // $ 筛选 模块
        formData:{
          goodsTit: "",
        },
        // 时间选择器的返回数组
        timeSelest:[],
        // $ 表格 模块
        tableData: [{}, {}, {}],
        // 添加抖音达人弹窗
        talentVisible: false,
      };
    },
    components:{
      talentDialog
    },
    methods:{
      // 添加达人弹窗
      addTalent(){
        this.talentVisible = true;
      },
      // 关闭弹窗
      close(info){
        if(info=='close'){
          this.talentVisible = false;
        }
      },
      // 弹窗成功回调
      success(info){
        if(info=='success'){
          this.talentVisible = false;
          // handle 重新请求列表数据 getData
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.banner {
  height: 130px;
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 10px;
}

// $ 筛选 模块
.pick-box {
  padding-top: 24px;
  padding-left: 24px;
  height: 122px;
  line-height: 1;
  background: #ffffff;
  box-shadow: 0px -1px 0px 0px #e6e7eb;
  border-radius: 4px 4px 0px 0px;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e7eb;
  .tit {
    font-size: 16px;
    color: #45474d;
    font-weight: bold;
    margin-bottom: 26px;
  }
  .main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
      display: flex;
      align-items: center;
      margin-right: 16px;
      .l {
        font-size: 14px;
        color: #8a8e99;
        margin-right: 8px;
      }
      .r {
        width: 150px;
      }
    }
    .btn-box {
      flex: 1;
      padding-right: 24px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      div {
        width: 50px;
        height: 32px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
      }
      .btn1 {
        background-color: #fe2c55;
        color: #fff;
        margin-right: 10px;
      }
      .btn2 {
        background-color: #ffffff;
        color: #45474d;
        border: 1px solid #e6e7eb;
      }
    }
  }
}

// $ 表格 模块
.table-box {
  margin-top: 10px;
  .goodsInfo {
    display: flex;
    align-items: center;
    img {
      width: 66px;
      height: 66px;
      background: #bfbfbf;
      border-radius: 50%;
      margin-right: 16px;
    }
    .r {
      font-size: 14px;
      color: #8a8e99;
      line-height: 1;
      .tit {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        color: #45474d;
        margin-bottom: 12px;
        color: #fe2c55;
      }
      .txt {
        margin-bottom: 12px;
      }
    }
  }
  .num-box {
    font-size: 14px;
    color: #8a8e99;
    span {
      color: #45474d;
    }
    > div {
      margin-bottom: 16px;
    }
  }
  .btn-box {
    display: flex;
    align-items: center;
    > div {
      margin-right: 20px;
      color: #fe2c55;
      cursor: pointer;
    }
  }
}
</style>